import { object } from "yup";
import { nonEmptyRequiredString, practitioner } from "../shared.js";
import { soadAssessmentCompletionStatusSchema } from "./helpers.js";
import { exampleSRFData } from "./srf.js";
export const soadNoCertPart1DataSchema = object({
    practitioner: practitioner(),
    reasons: nonEmptyRequiredString.required("Please give your reasons for not issuing a SOAD certificate."),
    completionStatus: soadAssessmentCompletionStatusSchema,
});
const user = {
    name: "Dr Bob",
    email: "bob@bob.com",
    address: "123 hospital",
    postalCode: "SE5",
    isGuest: false,
    isConfirmed: true,
};
export const exampleSoadNoCertData = [
    {
        data: {
            practitioner: user,
            reasons: "REASONS",
            completionStatus: "completed",
        },
        context: {
            patient: { name: "John Doe", address: "123 address", postalCode: "SE4" },
            user,
            formContext: { officialReferenceId: "1233445" },
            srfData: exampleSRFData.map(({ data }) => data),
        },
    },
];
//# sourceMappingURL=soad-nocert.js.map